import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import Joyride from 'react-joyride';
import axios from 'axios';
import Clipboard from 'react-clipboard.js';

import {
  obterItensTipoFTab,
  editarItem,
  adicionarItem,
} from '../actions/ItemActions';
import {
  obterFormandosPeloContrato,
  editarCamposFormando,
} from '../actions/FormandoActions';
import { cadastrarAcao } from '../actions/AcaoActions';
import {
  adicionarItemFormando,
  removerItemFormando,
} from '../actions/ItemFormandoActions';
import {
  editarContrato,
  descobrirContrato,
  editarCamposContrato,
} from '../actions/ContratoActions';
import { URL_PAGAMENTO } from '../config/urls';
import MapaService from '../services/MapaService';
import TelegramService from '../services/TelegramService';
import ModalPagamento from '../components/ModalPagamento';
import {
  GaleriaProduto,
  MiniaturaProduto,
} from '../components/GaleriaProduto';

class DistribuirItensFormando extends React.Component {
  state = {
    data: [],
    itens: [],
    valorPedido: 0,
    clienteMapa: {},
    formando: {},
    pix: {
      base64: '',
      copiaCola: '',
      carregando: true,
      showModal: false,
    },
    itemSelecionado: {},
    galeria: { produto: null },
    showModalInformacoes: false,
    showModalNotificacao: false,
    showModalDocumentoNaoCadastrado: false,
    showModalTermo: false,
    showModalPagamento: false,
    botaoFinalizar: false,
    run: false,
    tab: ['avulso', 'kit', 'itemFuturo'],
    // --- TUTORIAL ATUALIZADO PARA O NOVO LAYOUT ---
    steps: [
      {
        content: (
          <div>
            <h3>Bem-vindo(a) a página de distribuição dos produtos!</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              É aqui que você conseguirá ver os produtos contratados e fazer suas escolhas.
            </span>
          </div>
        ),
        placement: 'center',
        target: '#itens-disponiveis',
        disableBeacon: true,
      },
      {
        content: (
          <div>
            <h3>Resumo do Pedido</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Aqui você tem uma visão geral da quantidade de itens disponíveis e categorias.
            </span>
          </div>
        ),
        placement: 'bottom',
        target: '#card-resumo',
      },
      {
        content: (
          <div>
            <h3>Lista de Produtos</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Esta é a lista completa dos itens disponíveis para você adquirir.
            </span>
          </div>
        ),
        placement: 'top',
        target: '#lista-produtos',
      },
      {
        content: (
          <div>
            <h3>Definir Quantidade</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Informe aqui quantos itens deste produto você deseja. O valor será calculado automaticamente.
            </span>
          </div>
        ),
        placement: 'left',
        target: '.input-quantidade-container', 
      },
      {
        content: (
          <div>
            <h3>Valor Total</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Acompanhe aqui o valor total do seu pedido conforme você adiciona itens.
            </span>
          </div>
        ),
        placement: 'top',
        target: '#footer-total',
      },
      {
        content: (
          <div>
            <h3>Finalizar Compra</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Após escolher todos os itens, clique aqui para prosseguir para o pagamento.
            </span>
          </div>
        ),
        placement: 'top',
        target: '#btn-finalizar-compra',
      },
    ],
  };

  async componentWillMount() {
    await this.props
      .descobrirContrato(
        this.props.usuario.tipo,
        this.usuarioEhFormando()
          ? this.props.numeroContrato
          : this.props.usuario.id
      )
      .then(async () => {
        if (
          !this.usuarioEhFormando() ||
          this.props.contrato.sistemaPagto === 0
        ) {
          this.props.history.push('./');
        } else {
          this.carregarDados();
        }
      });
  }

  abrirGaleria(item) {
    this.setState({
      galeria: { produto: { nome: item.produto, fotos: item.fotos } },
    });
  }

  fecharGaleria() {
    this.setState({ galeria: { produto: null } });
  }

  contratoTemKit() {
    return this.props.itens && this.props.itens.some((item) => item.observacao === 'kit');
  }

  formandoJaComprouKit(formando, itens) {
    if (!formando || !formando.itens) return false;
    return formando.itens.some((itemComprado) => {
      if (itemComprado.tipo === 'brinde') return false;
      let itemPesquisado = itens.find((i) => i.id === itemComprado.item);
      return (
        itemPesquisado &&
        itemPesquisado.observacao === 'kit' &&
        itemPesquisado.produto.substring(0, 3).toLowerCase() === 'kit' &&
        itemComprado.quantidade > 0
      );
    });
  }

  avulsosEstaoLiberados(formando, itens) {
    if (this.props.contrato.avulsosLiberados === 1) return true;
    if (!this.contratoTemKit()) return true;
    return this.formandoJaComprouKit(formando, itens);
  }

  /**
   * Quantidades escolhidas na tabela da tela inicial. Chegam pelo state da
   * rota e valem so na primeira carga: `carregarDados` roda de novo depois do
   * pagamento e, sem isso, o pedido voltaria preenchido e reabriria o modal.
   */
  consumirSelecaoDoContrato() {
    const vazio = { quantidades: {}, irParaPagamento: false };

    if (this.selecaoConsumida) return vazio;
    this.selecaoConsumida = true;

    const estado = (this.props.location && this.props.location.state) || {};

    if (!estado.quantidades && !estado.irParaPagamento) return vazio;

    // Limpa o state da rota para um F5 nao repetir a selecao.
    this.props.history.replace(this.props.location.pathname);

    return {
      quantidades: estado.quantidades || {},
      irParaPagamento: estado.irParaPagamento === true,
    };
  }

  async carregarDados() {
    await this.props.obterItensTipoFTab(this.props.contrato.id, this.state.tab);
    await this.props.obterFormandosPeloContrato(this.props.contrato.id);

    let mapa = new MapaService(),
      formando = this.props.formandos.filter((formando) => {
        return (
          formando.usuario && formando.usuario.id === this.props.usuario.id
        );
      })[0],
      turma = this.props.contrato.turmas.filter((turma) => {
        return turma.id === formando.turma;
      })[0],
      itens = Object.assign([], this.props.itens);

    itens.map((item) => {
      return (item.quantidade = 0);
    });

    const selecao = this.consumirSelecaoDoContrato();
    let valorPedido = 0;

    itens.forEach((item) => {
      const escolhida = Number(selecao.quantidades[item.id]) || 0;

      if (escolhida > 0) item.quantidade = escolhida;

      valorPedido +=
        item.quantidade *
        (this.ehItemFuturo(item) ? item.valorAdendo : item.preco);
    });

    // Sem CPF ou sem termo aceito o formando resolve isso antes de pagar, e
    // com a distribuicao encerrada nao ha compra nenhuma a abrir.
    const bloqueado =
      !formando.documento ||
      formando.documento === '' ||
      !formando.aceitouTermo ||
      this.distribuiuItens();
    const abrirPagamento =
      selecao.irParaPagamento && !bloqueado && valorPedido > 0;

    if (!formando.documento || formando.documento === '') {
      this.setState({ showModalDocumentoNaoCadastrado: true });
    } else if (!formando.aceitouTermo) {
      mapa
        .getTabela(this.props.contrato.numOrcamento)
        .then((response) => {
          this.setState({
            showModalTermo: true,
            clienteMapa: {
              instituicao: response.Instituicao,
              cidade: response.Cidade,
              turma: turma.curso,
            },
          });
        })
        .catch((erro) => {
          new TelegramService().novo('ERROR', [
            JSON.stringify(erro),
            'Falha no getTabela',
            `usuarioLogado: ${JSON.parse(sessionStorage.getItem('usuarioLogadoComissao')).login
            }`,
          ]);
        });
    } else if (!abrirPagamento) {
      // O tutorial atrapalharia quem ja veio decidido, direto para o pagamento.
      this.executarJoyride();
    }

    this.setState({ formando, itens, valorPedido }, () => {
      if (abrirPagamento) this.abrirModalPagamento();
    });
  }

  usuarioEhFormando() {
    return this.props.usuario.tipo === 'formando';
  }

  distribuiuItens() {
    return this.props.contrato.distribuiuItens === 1;
  }

  formatarMoedaBR(valor) {
    if (valor) {
      valor = valor.toFixed(2).split('.');
      valor[0] = valor[0].split(/(?=(?:...)*$)/).join('.');
      return valor.join(',');
    }
    return '0,00';
  }

  abrirModalPagamento() {
    if (this.state.valorPedido < 10) {
      toast.info('Atinja pelo menos R$ 10,00 em compras!');
    } else {
      let data = [
        {
          id: this.state.formando.id,
          nome: this.state.formando.nome,
          itens: [],
        },
      ],
        avulsosLiberados = true,
        itens = Object.assign([], this.props.itens);

      this.state.itens.forEach((item) => {
        if (item.quantidade > 0) {
          data[0].itens.push({
            idProduto: item.id,
            produto: item.produto,
            quantidade: item.quantidade,
            preco: this.ehItemFuturo(item) ? item.valorAdendo : item.preco,
            total:
              (this.ehItemFuturo(item) ? item.valorAdendo : item.preco) *
              item.quantidade,
          });
        }
      });

      if (this.props.contrato.avulsosLiberados !== 1 && this.contratoTemKit()) {
        avulsosLiberados = false;

        // Verifica se já comprou kit em pedidos anteriores
        this.state.formando.itens.forEach((itemComprado) => {
          if (itemComprado.tipo !== 'brinde') {
            let itemPesquisado = itens.filter((i) => i.id === itemComprado.item)[0];
            if (
              itemPesquisado &&
              itemPesquisado.observacao === 'kit' &&
              itemPesquisado.produto.substring(0, 3).toLowerCase() === 'kit' &&
              itemComprado.quantidade > 0
            ) {
              avulsosLiberados = true;
            }
          }
        });

        // Verifica se está comprando kit neste pedido
        if (!avulsosLiberados) {
          data[0].itens.forEach((itemComprado) => {
            let itemPesquisado = itens.filter((i) => i.id === itemComprado.idProduto)[0];
            if (
              itemPesquisado &&
              itemPesquisado.observacao === 'kit' &&
              itemPesquisado.produto.substring(0, 3).toLowerCase() === 'kit'
            ) {
              avulsosLiberados = true;
            }
          });
        }
      }

      if (avulsosLiberados) {
        this.setState({ showModalPagamento: true, data });
      } else {
        toast.error('É obrigatória a compra de pelo menos 1 Kit!');
      }
    }
  }

  ehItemFuturo = (item) => {
    return item.observacao === 'itemFuturo';
  };

  copiarPix() {
    navigator.clipboard.writeText(this.state.pix.copiaCola);
    toast.success('Copiado com sucesso!');
  }

  async handleCloseModalPagamento(resposta) {
    if (resposta) {
      const sucesso = resposta.status >= 200 && resposta.status < 300;

      if (sucesso) {
        this.carregarDados();
        if (resposta.formaPagamento === "PIX") {
          this.setState({ pix: { ...this.state.pix, showModal: true } });

          // A resposta já vem com o QR Code da nova API
          if (resposta.data && resposta.data.qrCode) {
            const qrCode = resposta.data.qrCode;
            this.setState({ pix: { ...this.state.pix, base64: qrCode.encodedImage, copiaCola: qrCode.payload, carregando: false } });
          } else {
            this.setState({ showModalVerPedidos: true });
          }
        } else {
          this.setState({ showModalVerPedidos: true });
        }
      } else if (resposta.status) {
        // O modal manda o motivo real da recusa (CPF, cartão, sessão expirada).
        // O texto genérico só sobra quando a API não informa nada, e antes ele
        // era o único que aparecia, em qualquer falha.
        toast.error(
          resposta.mensagemErro ||
          "Não foi possível finalizar a compra do seu pedido. Tente novamente mais tarde!",
          { autoClose: 10000 }
        );
      }
    }
    // Add delay to allow React to complete DOM reconciliation before closing modal
    setTimeout(() => {
      this.setState({ showModalPagamento: false });
    }, 150);
  }

  handleClickTermoAditamento() {
    this.props
      .editarCamposFormando(this.state.formando.id, { aceitouTermo: 1 })
      .then(() => {
        this.setState({ showModalTermo: false });
        this.executarJoyride();
      })
      .catch((erro) => {
        console.log(erro);
      });
  }

  handleChangeQuantidadeItem = (id, quantidade) => {
    let { itens } = this.state,
      valorPedido = 0;

    itens.forEach((item) => {
      if (item.id === id) {
        item.quantidade = Number(quantidade);
      }
    });

    // Se não há kit selecionado e o contrato exige kit, zera avulsos
    const kitSelecionado = itens.some(
      (item) => item.observacao === 'kit' && item.produto.substring(0, 3).toLowerCase() === 'kit' && item.quantidade > 0
    );
    const exigeKit = this.props.contrato.avulsosLiberados !== 1 && this.contratoTemKit() && !this.formandoJaComprouKit(this.state.formando, this.props.itens);

    if (exigeKit && !kitSelecionado) {
      itens.forEach((item) => {
        if (item.observacao === 'avulso') item.quantidade = 0;
      });
    }

    itens.forEach((item) => {
      let valor = this.ehItemFuturo(item) ? item.valorAdendo : item.preco;
      valorPedido += item.quantidade * valor;
    });

    this.setState({ itens, valorPedido });
  };

  executarJoyride() {
    if (localStorage.getItem('tutorialDistribuicaoItens') === null) {
      this.setState({ run: true });
      localStorage.setItem('tutorialDistribuicaoItens', true);
    }
  }

  _renderAlerta() {
    return this.distribuiuItens() ? (
      <div
        style={{
          background: '#f0fdf4',
          border: '1px solid #86efac',
          color: '#166534',
          borderRadius: 8,
          padding: '16px 20px',
          marginBottom: 20,
          fontWeight: 600,
          fontSize: 14,
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
        }}
      >
        <div style={{
          background: '#22c55e',
          color: 'white',
          borderRadius: '50%',
          width: 24,
          height: 24,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <i className='fa fa-check' style={{ fontSize: 12 }}></i>
        </div>
        Etapa concluída com sucesso!
      </div>
    ) : null;
  }

  avulsosLiberadosAgora() {
    if (this.props.contrato.avulsosLiberados === 1) return true;
    if (!this.contratoTemKit()) return true;
    // Verifica se já comprou kit anteriormente
    if (this.formandoJaComprouKit(this.state.formando, this.props.itens)) return true;
    // Verifica se está selecionando um kit agora
    return this.state.itens && this.state.itens.some(
      (item) => item.observacao === 'kit' && item.produto.substring(0, 3).toLowerCase() === 'kit' && item.quantidade > 0
    );
  }

  render() {
    const { itens, valorPedido, botaoFinalizar } = this.state;
    const avulsosLiberados = this.avulsosLiberadosAgora();
    const temApenasAvulso = !avulsosLiberados && this.state.itens && this.state.itens.some((item) => item.observacao === 'avulso' && item.quantidade > 0);
    // (Styles removidos para economizar espaço visual, mas continuam aplicados inline abaixo)
    
    return (
      <div
        id='itens-disponiveis' // ALVO DO PASSO 1 DO TUTORIAL
        style={{ paddingBottom: 100, backgroundColor: '#f1f5f9', minHeight: '100vh', fontFamily: "'Inter', sans-serif" }}
      >
        {/* Dark Hero Header */}
        <div style={{
          background: '#222d32',
          color: 'white',
          padding: '40px 0 60px',
          marginBottom: -30
        }}>
          <div className='container'>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', flexWrap: 'wrap', gap: 20 }}>
              <div>
                <h4 style={{ color: '#94a3b8', fontSize: 14, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 8 }}>
                  Distribuição de Itens
                </h4>
                <h2 style={{ color: 'white', fontSize: 32, fontWeight: 800, margin: 0 }}>
                  Selecione seus produtos
                </h2>
              </div>
              <div style={{
                background: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(10px)',
                padding: '10px 20px',
                borderRadius: 50,
                border: '1px solid rgba(255,255,255,0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: 10
              }}>
                <i className="fa fa-file-text-o"></i>
                <span style={{ fontWeight: 600 }}>Contrato #{this.props.contrato.numero || '--'}</span>
              </div>
            </div>
          </div>
        </div>

        <div className='container'>
          {this._renderAlerta()}

          {/* Summary Cards Row */}
          <div className='row' style={{ marginBottom: 32 }}>
            <div className='col-md-8'>
              <div
                id='card-resumo' // ALVO DO PASSO 2 DO TUTORIAL
                style={{
                  background: 'white',
                  borderRadius: 16,
                  padding: 24,
                  boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}>
                <div>
                  <div style={{ color: '#64748b', fontWeight: 600, fontSize: 14 }}>Itens Selecionados</div>
                  <div style={{ fontSize: 24, fontWeight: 800, color: '#0f172a' }}>{itens.length} itens disponíveis</div>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  {['Avulsos', 'Kits', 'Itens futuros'].map(label => (
                    <span key={label} style={{
                      background: '#f8fafc',
                      padding: '6px 12px',
                      borderRadius: 8,
                      fontSize: 12,
                      fontWeight: 600,
                      color: '#475569',
                      border: '1px solid #e2e8f0'
                    }}>{label}</span>
                  ))}
                </div>
              </div>
            </div>
            <div className='col-md-4'>
            </div>
          </div>

          {/* New Card List Layout */}
          {itens.length > 0 ? (
            <div className='row' id='lista-produtos'> {/* ALVO DO PASSO 3 DO TUTORIAL */}
              {itens.map((item, i) => (
                <div key={i} className='col-md-12' style={{ marginBottom: 16 }}>
                  {(() => {
                    const bloqueado = item.observacao === 'avulso' && !avulsosLiberados;
                    return (
                  <div style={{
                    background: bloqueado ? '#f8fafc' : 'white',
                    borderRadius: 16,
                    padding: 24,
                    border: bloqueado ? '1px solid #e2e8f0' : '1px solid #e2e8f0',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 20,
                    transition: 'all 0.2s ease',
                    borderLeft: bloqueado ? '4px solid #f59e0b' : item.quantidade > 0 ? '4px solid #dc2626' : '1px solid #e2e8f0',
                    opacity: bloqueado ? 0.7 : 1,
                  }}>
                    <MiniaturaProduto
                      produto={{ nome: item.produto, fotos: item.fotos }}
                      tamanho={72}
                      esmaecida={bloqueado}
                      onClick={() => this.abrirGaleria(item)}
                    />

                    {/* Product Info */}
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <h5 style={{ fontWeight: 700, color: bloqueado ? '#94a3b8' : '#0f172a', marginBottom: 4, fontSize: 18 }}>{item.produto}</h5>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <span style={{ color: '#64748b', fontSize: 14, fontWeight: 500 }}>
                          Unidade: <strong style={{ color: '#334155' }}>R$ {this.formatarMoedaBR(this.ehItemFuturo(item) ? item.valorAdendo : item.preco)}</strong>
                        </span>
                        {bloqueado && (
                          <span style={{
                            background: '#fef3c7',
                            color: '#92400e',
                            padding: '3px 10px',
                            borderRadius: 20,
                            fontSize: 11,
                            fontWeight: 700,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 4
                          }}>
                            <i className="fa fa-lock"></i> Selecione um kit primeiro
                          </span>
                        )}
                        {(((item.itens || '').replace(/;/g, '').trim().length > 0) ||
                          ((item.descricao || '').trim().length > 0)) && (
                          <span
                            onClick={() => this.setState({ itemSelecionado: item, showModalInformacoes: true })}
                            style={{
                              cursor: 'pointer',
                              background: '#fff7ed',
                              color: '#ea580c',
                              padding: '4px 10px',
                              borderRadius: 20,
                              fontSize: 11,
                              fontWeight: 700,
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: 4
                            }}
                          >
                            <i className="fa fa-eye"></i> Ver composição
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Actions */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 30, flexWrap: 'wrap' }}>
                      <div
                        className='input-quantidade-container' // ALVO DO PASSO 4 DO TUTORIAL
                        style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}
                      >
                        <label style={{ fontSize: 12, fontWeight: 600, color: '#64748b', marginBottom: 4 }}>QUANTIDADE</label>
                        {this.distribuiuItens() ? (
                          <div style={{ fontSize: 20, fontWeight: 700, color: '#0f172a' }}>{item.quantidade}</div>
                        ) : item.observacao === 'avulso' && !avulsosLiberados ? (
                          <div title='Adicione um kit primeiro para liberar os avulsos' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                            <input
                              type='number'
                              min='0'
                              disabled
                              style={{
                                width: 100,
                                padding: '8px 12px',
                                borderRadius: 8,
                                border: '1px solid #e2e8f0',
                                fontSize: 16,
                                fontWeight: 600,
                                color: '#94a3b8',
                                textAlign: 'center',
                                background: '#f8fafc',
                                cursor: 'not-allowed'
                              }}
                              value={0}
                              onChange={() => {}}
                            />
                            <span style={{ fontSize: 10, color: '#ef4444', fontWeight: 600 }}>Requer kit</span>
                          </div>
                        ) : (
                          <input
                            type='number'
                            min='0'
                            style={{
                              width: 100,
                              padding: '8px 12px',
                              borderRadius: 8,
                              border: '1px solid #cbd5e1',
                              fontSize: 16,
                              fontWeight: 600,
                              color: '#0f172a',
                              textAlign: 'center'
                            }}
                            value={item.quantidade}
                            onChange={(e) => this.handleChangeQuantidadeItem(item.id, e.target.value)}
                          />
                        )}
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', minWidth: 100 }}>
                        <label style={{ fontSize: 12, fontWeight: 600, color: '#64748b', marginBottom: 4 }}>TOTAL</label>
                        <div style={{ fontSize: 20, fontWeight: 800, color: item.quantidade > 0 ? '#dc2626' : '#94a3b8' }}>
                          R$ {this.formatarMoedaBR(item.quantidade * (this.ehItemFuturo(item) ? item.valorAdendo : item.preco))}
                        </div>
                      </div>
                    </div>
                  </div>
                  );
                  })()}
                </div>
              ))}

              {/* Sticky Action Footer */}
              <div style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                background: 'white',
                padding: '20px 0',
                boxShadow: '0 -4px 20px rgba(0,0,0,0.1)',
                borderTop: '1px solid #e2e8f0',
                zIndex: 100
              }}>
                <div className='container' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div id='footer-total'> {/* ALVO DO PASSO 5 DO TUTORIAL */}
                    <div style={{ fontSize: 13, color: '#64748b', fontWeight: 600 }}>VALOR FINAL DO PEDIDO</div>
                    <div style={{ fontSize: 28, fontWeight: 800, color: '#0f172a' }}>R$ {this.formatarMoedaBR(valorPedido)}</div>
                  </div>

                  {this.distribuiuItens() ? (
                    <button disabled className='btn' style={{ background: '#f1f5f9', color: '#94a3b8', padding: '12px 24px', borderRadius: 8, fontWeight: 600 }}>
                      <i className='fa fa-lock'></i> Compra bloqueada
                    </button>
                  ) : temApenasAvulso ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6 }}>
                      <button disabled className='btn' style={{ background: '#f1f5f9', color: '#94a3b8', padding: '14px 40px', borderRadius: 8, fontSize: 16, fontWeight: 700, border: 'none', display: 'flex', alignItems: 'center', gap: 10, cursor: 'not-allowed' }}>
                        <i className='fa fa-lock'></i> Finalizar Compra
                      </button>
                      <span style={{ fontSize: 12, color: '#ef4444', fontWeight: 600 }}>
                        <i className='fa fa-exclamation-triangle'></i> Adicione pelo menos 1 kit para continuar
                      </span>
                    </div>
                  ) : (
                    <button
                      id='btn-finalizar-compra' // ALVO DO PASSO 6 DO TUTORIAL
                      onClick={() => this.abrirModalPagamento()}
                      disabled={botaoFinalizar}
                      className='btn'
                      style={{
                        background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
                        color: 'white',
                        padding: '14px 40px',
                        borderRadius: 8,
                        fontSize: 16,
                        fontWeight: 700,
                        boxShadow: '0 4px 12px rgba(220, 38, 38, 0.4)',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10
                      }}
                    >
                      {botaoFinalizar ? <i className='fa fa-spinner fa-spin'></i> : 'Finalizar Compra'} <i className='fa fa-arrow-right'></i>
                    </button>
                  )}
                </div>
              </div>

            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '100px 0' }}>
              <h3 style={{ color: '#94a3b8' }}>Nenhum item disponível.</h3>
            </div>
          )}
        </div>
        <Modal
          show={this.state.showModalPagamento}
          onHide={() => setTimeout(() => this.setState({ showModalPagamento: false }), 150)}
          id='modalPagamento'
          animation={false}
        >
          <ModalPagamento
            contrato={this.props.contrato}
            data={this.state.data}
            formando={this.state.formando}
            formatarMoedaBR={this.formatarMoedaBR}
            close={(response) => this.handleCloseModalPagamento(response)}
            usuarioLogado={this.props.usuario}
          />
        </Modal>
        <Modal
          show={this.state.showModalNotificacao}
          onHide={() => {
            this.setState({ showModalNotificacao: false });
          }}
          dialogClassName='modal-80w'
          animation={false}
        >
          <Modal.Body>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
              <img src="./images/success.png" alt="Sucesso" height="75" />
              <h2 style={{ textAlign: "center" }}>Distribuição de itens finalizada!</h2>
              {
                this.props.contrato.pagamentoIndividual === "true" ?
                  <h4 style={{ textAlign: "center" }}><strong>Enviamos um e-mail para todos os formandos com as informações sobre o pagamento.</strong></h4>
                  : null
              }
              {
                this.props.contrato.contratante && this.props.contrato.contratante.includes("Alpha-e") ?
                  <a href="./entrega" className="btn btn-outline-success btn-lg" style={{ marginTop: 17 }}>Acompanhar pagamento</a>
                  : <React.Fragment>
                    <h4 style={{ textAlign: "center" }}>A próxima etapa agora é o cadastro das informações para faturamento/entrega.</h4>
                    <a href="./entrega" className="btn btn-outline-success btn-lg" style={{ marginTop: 17 }}>Vamos lá!</a>
                  </React.Fragment>
              }
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showModalVerPedidos}
          onHide={() => {
            this.setState({ showModalVerPedidos: false });
          }}
          dialogClassName='modal-80w'
          animation={false}
        >
          <Modal.Body style={{ padding: '50px 40px', background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <div style={{
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                width: '100px',
                height: '100px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '24px',
                boxShadow: '0 15px 40px rgba(16, 185, 129, 0.3)',
                animation: 'successPulse 2s ease-in-out infinite'
              }}>
                <i className='fa fa-check' style={{ color: 'white', fontSize: '48px' }}></i>
              </div>
              <h2 style={{
                textAlign: 'center',
                color: '#1e293b',
                fontWeight: '700',
                fontSize: '32px',
                marginBottom: '16px'
              }}>
                Compra efetuada com sucesso!
              </h2>
              {this.usuarioEhFormando() ? (
                <div style={{
                  background: 'white',
                  padding: '20px 24px',
                  borderRadius: '12px',
                  border: '2px solid #86efac',
                  marginBottom: '32px',
                  maxWidth: '500px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                    <i className='fa fa-envelope' style={{ color: '#10b981', fontSize: '20px', marginTop: '2px' }}></i>
                    <p style={{
                      textAlign: 'left',
                      color: '#334155',
                      fontSize: '15px',
                      margin: 0,
                      lineHeight: '1.6'
                    }}>
                      <strong style={{ color: '#1e293b' }}>Em breve você receberá um e-mail</strong> com a confirmação do seu pedido. Fique ligado(a)!
                    </p>
                  </div>
                </div>
              ) : null}
              <Link to='./meus-pedidos'>
                <button
                  className="btn-ver-pedidos"
                  style={{
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                    color: 'white',
                    border: 'none',
                    padding: '16px 40px',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    fontWeight: '700',
                    fontSize: '16px',
                    boxShadow: '0 6px 20px rgba(16, 185, 129, 0.3)',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                  }}
                >
                  <i className='fa fa-shopping-bag'></i>
                  Ver meus pedidos
                </button>
              </Link>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.pix.showModal} dialogClassName='modal-80w' animation={false}>
          <Modal.Body style={{ padding: '40px', background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <div style={{
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                width: '80px',
                height: '80px',
                borderRadius: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '40px',
                marginBottom: '24px',
                boxShadow: '0 10px 30px rgba(16, 185, 129, 0.3)'
              }}>
                💰
              </div>
              <h2 style={{
                textAlign: 'center',
                marginBottom: '12px',
                color: '#1e293b',
                fontWeight: '700',
                fontSize: '28px'
              }}>
                Pagamento via PIX
              </h2>
              <p style={{
                textAlign: 'center',
                color: '#64748b',
                fontSize: '16px',
                marginBottom: '32px',
                maxWidth: '500px'
              }}>
                Escaneie o QR Code abaixo com o aplicativo do seu banco ou copie o código Pix Copia e Cola
              </p>
              {this.state.pix.carregando ? (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '60px',
                    gap: '20px'
                  }}
                >
                  <i className='fa fa-spin fa-spinner' style={{ fontSize: '48px', color: '#dc3545' }}></i>
                  <span style={{ color: '#64748b', fontSize: '16px', fontWeight: '500' }}>Gerando QR Code...</span>
                </div>
              ) : (
                <React.Fragment>
                  <div style={{
                    background: 'white',
                    padding: '24px',
                    borderRadius: '16px',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                    marginBottom: '24px'
                  }}>
                    <img
                      src={`data:image/jpeg;base64,${this.state.pix.base64}`}
                      alt='QRCODE Pix'
                      style={{
                        width: '240px',
                        height: '240px',
                        display: 'block'
                      }}
                    />
                  </div>
                  <div style={{
                    width: '100%',
                    maxWidth: '500px',
                    marginBottom: '24px'
                  }}>
                    <label style={{
                      display: 'block',
                      marginBottom: '10px',
                      color: '#334155',
                      fontWeight: '600',
                      fontSize: '14px'
                    }}>
                      Código Pix Copia e Cola
                    </label>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <input
                        type='text'
                        className='form-control'
                        value={this.state.pix.copiaCola}
                        style={{
                          flex: 1,
                          padding: '14px 16px',
                          border: '2px solid #e2e8f0',
                          borderRadius: '10px',
                          fontSize: '14px',
                          fontFamily: 'monospace',
                          background: 'white',
                          color: '#1e293b'
                        }}
                        readOnly
                      />
                    </div>
                    <div
                      className='col-xs-4 col-sm-3'
                      style={{ paddingLeft: 0 }}
                    >
                      <button
                        className="btn-copiar-pix"
                        style={{
                          background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                          color: 'white',
                          border: 'none',
                          padding: '14px 24px',
                          borderRadius: '10px',
                          cursor: 'pointer',
                          fontWeight: '600',
                          fontSize: '14px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          boxShadow: '0 4px 12px rgba(220, 53, 69, 0.3)',
                          transition: 'all 0.3s ease'
                        }}
                        onClick={this.copiarPix.bind(this)}
                      >
                        <i className='fas fa-clipboard'></i> Copiar
                      </button>
                    </div>
                  </div>
                  <div style={{
                    background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                    padding: '16px 20px',
                    borderRadius: '12px',
                    border: '1px solid #93c5fd',
                    marginBottom: '24px',
                    maxWidth: '500px',
                    width: '100%'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                      <i className='fa fa-info-circle' style={{ color: '#1e40af', fontSize: '18px', marginTop: '2px' }}></i>
                      <div style={{ fontSize: '14px', color: '#1e40af', lineHeight: '1.6' }}>
                        <strong>Importante:</strong> O pagamento é processado instantaneamente após a confirmação do PIX.
                      </div>
                    </div>
                  </div>
                  <button
                    className="btn-concluir"
                    style={{
                      background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                      color: 'white',
                      border: 'none',
                      padding: '14px 40px',
                      borderRadius: '10px',
                      cursor: 'pointer',
                      fontWeight: '700',
                      fontSize: '16px',
                      boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() =>
                      this.setState({
                        pix: { ...this.state.pix, showModal: false },
                      })
                    }
                  >
                    Concluir
                  </button>
                </React.Fragment>
              )}
            </div>
          </Modal.Body>
        </Modal>
        <GaleriaProduto
          produto={this.state.galeria.produto}
          onFechar={this.fecharGaleria.bind(this)}
        />

        <Modal
          show={this.state.showModalInformacoes !== false}
          onHide={() => {
            this.setState({ showModalInformacoes: false });
          }}
          dialogClassName='modal-50w'
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Outras informações</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.itemSelecionado !== null &&
              this.state.itemSelecionado.itens !== undefined ? (
              <div>
                <h4>Composição</h4>
                <ul style={{ marginBottom: 30 }}>
                  {this.state.itemSelecionado.itens
                    .split(';')
                    .map((item, i) =>
                      item !== '' ? <li key={i}>{item}</li> : null
                    )}
                </ul>
              </div>
            ) : null}
            {this.state.itemSelecionado !== null &&
              this.state.itemSelecionado.descricao !== undefined ? (
              <div>
                <h4>Produtos utilizados</h4>
                <ul>
                  {this.state.itemSelecionado.descricao
                    .split(' / ')
                    .map((descricao, i) =>
                      descricao !== ''
                        ? descricao
                          .split(',')
                          .map((desc, j) => (
                            <li key={'desc' + i + j}>{desc}</li>
                          ))
                        : null
                    )}
                </ul>
              </div>
            ) : null}
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showModalDocumentoNaoCadastrado}
          dialogClassName='modal-80w'
          animation={false}
        >
          <Modal.Body style={{ padding: '50px 40px', background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <div style={{
                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                width: '90px',
                height: '90px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '24px',
                boxShadow: '0 15px 40px rgba(245, 158, 11, 0.3)'
              }}>
                <i className='fa fa-exclamation' style={{ color: 'white', fontSize: '48px' }}></i>
              </div>
              <h2 style={{
                textAlign: 'center',
                color: '#1e293b',
                fontWeight: '700',
                fontSize: '28px',
                marginBottom: '16px'
              }}>
                Dados incompletos!
              </h2>
              <div style={{
                background: 'white',
                padding: '24px',
                borderRadius: '12px',
                border: '2px solid #fbbf24',
                marginBottom: '32px',
                maxWidth: '500px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
              }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
                  <i className='fa fa-info-circle' style={{ color: '#f59e0b', fontSize: '22px', marginTop: '2px' }}></i>
                  <p style={{
                    textAlign: 'left',
                    color: '#334155',
                    fontSize: '15px',
                    margin: 0,
                    lineHeight: '1.6'
                  }}>
                    Para realizar uma compra é <strong style={{ color: '#1e293b' }}>necessário que seus dados estejam completos</strong> no sistema. Por favor, complete seu cadastro antes de continuar.
                  </p>
                </div>
              </div>
              <a
                href='./meus-dados'
                className="btn-completar-cadastro"
                style={{
                  background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                  color: 'white',
                  border: 'none',
                  padding: '16px 40px',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  fontWeight: '700',
                  fontSize: '16px',
                  boxShadow: '0 6px 20px rgba(245, 158, 11, 0.3)',
                  transition: 'all 0.3s ease',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px'
                }}
              >
                <i className='fa fa-user-edit'></i>
                Completar cadastro
              </a>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.showModalTermo} dialogClassName='modal-80w'>
          <Modal.Body style={{
            padding: '40px',
            background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)'
          }}>
            <div style={{
              background: 'white',
              padding: '32px',
              borderRadius: '16px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              marginBottom: '24px'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '24px',
                paddingBottom: '20px',
                borderBottom: '3px solid #dc3545'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                  width: '60px',
                  height: '60px',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 6px 16px rgba(220, 53, 69, 0.3)'
                }}>
                  <i className='fa fa-file-contract' style={{ color: 'white', fontSize: '28px' }}></i>
                </div>
                <h3
                  style={{
                    margin: 0,
                    fontWeight: 700,
                    fontSize: '24px',
                    color: '#1e293b',
                    lineHeight: '1.3'
                  }}
                >
                  ADITAMENTO DE CONTRATO DE PRESTAÇÃO DE SERVIÇOS
                </h3>
              </div>
              <div style={{
                fontSize: '15px',
                color: '#334155',
                lineHeight: '1.8',
                maxHeight: '500px',
                overflowY: 'auto',
                padding: '20px',
                background: '#f8fafc',
                borderRadius: '12px',
                border: '1px solid #e2e8f0'
              }}>
                <p>
                  Pelo presente Aditamento de Contrato de Prestação de Serviços de
                  Convites de Formatura, que firmam entre si, de um lado a empresa
                  Beta Imagem Empresa Fotográfica Eireli, inscrita no CNPJ/MF sob
                  o nº 07.093.119/0001-03, inscrição estadual nº 903.29089-74, com
                  sede em Bandeirantes, Estado do Paraná, Rua São Paulo, 1990,
                  Centro, CEP 86360-000, doravante denominada somente Alpha
                  Convites; E de outro lado como futuro "formando", e que assinam
                  o presente contrato, a saber:
                </p>
                <ul style={{ paddingLeft: 17 }}>
                  <li>Do curso: {this.state.clienteMapa.turma};</li>
                  <li>Da instituição: {this.state.clienteMapa.instituicao};</li>
                  <li>Da cidade de: {this.state.clienteMapa.cidade};</li>
                  <li>
                    Cuja formatura ocorrerá em:{' '}
                    {this.props.contrato.dataFormatura
                      ? this.props.contrato.dataFormatura
                        .split('T')[0]
                        .split('-')
                        .reverse()
                        .join('/')
                      : null}
                    ;
                  </li>
                </ul>
                <p>
                  <strong>Cláusula Primeira:</strong> Assume o aluno perante a
                  Alpha Convites, os compromissos do CONTRATO DE PRESTAÇÃO DE
                  SERVIÇOS, firmado entre a Alpha Convites e a Comissão de
                  Formatura que os representa.
                </p>
                <p>
                  <strong>Cláusula Segunda:</strong> O aluno abaixo assinado
                  declara que tem ciência do contrato assinado com a Comissão de
                  Formatura, quanto a aquisição de CONVITES PARA FORMATURA, nas
                  formas ali estabelecidas e a este adere, não podendo,
                  individualmente, alegar desconhecimento dos termos, haja vista a
                  peculiaridade contratual.
                </p>
                <p>
                  <strong>§1º:</strong> O aluno que por ventura venha a “REPROVAR”
                  terá assegurado o direito de devolução no valor de 30% (trinta
                  por cento) sendo esse benefício até o prazo máximo de 30 dias
                  antes da entrada de produção e que o mesmo já tenha quitado todo
                  o valor. A devolução do valor especificado será efetuada pela
                  Alpha Convites, através de depósito ao aluno reprovado, mediante
                  documento de solicitação e comprovação emitido pela Diretoria da
                  Comissão de Formatura.
                </p>
                <p>
                  <strong>Cláusula Terceira:</strong> O aluno está devidamente
                  ciente que caso haja atraso no pagamento, implicará no pagamento
                  em multa de 2% (dois por cento) do valor da parcela,
                  monetariamente corrigida, mais juros pro rata die de 1% (um por
                  cento) ao mês.
                </p>
                <p>
                  <strong>Cláusula Quarta:</strong> Para adesão é necessário que o
                  aluno informe todos seus dados pessoais.
                </p>
                <p>
                  <strong>Cláusula Quinta:</strong> O aluno acima identificado têm
                  ciência e autoriza a Comissão constante no contrato, a assinar
                  outros aditamentos ao Contrato de Prestação de Serviços,
                  alterações no orçamento inicial, por ampliação ou diminuição dos
                  itens que o compõem, implicando em aumento ou redução do valor
                  do contrato e outros que se tornem necessários.
                </p>
                <p>
                  <strong>Cláusula Sexta:</strong> Os produtos aqui contratados
                  são de ordem individual, tanto a quantidade como o pagamento,
                  porém, a contratada produzirá a soma mínima estipulada no
                  contrato de prestação de serviço (contrato n°{' '}
                  {this.props.contrato.numero} / proposta n°{' '}
                  {this.props.contrato.numOrcamento}). Havendo diminuição de
                  integrantes ou por inadimplência ou desistência, os convites que
                  sobrarem e a diferença do valor restante para a quitação desses
                  serviços serão rateadas entre todos os membros da turma que
                  constem em contratos individuais, de acordo com esse termo de
                  adesão, sendo o envio do produto condicionado a quitação do
                  contrato.
                </p>
                <p>
                  <strong>§1º:</strong> Os produtos contratados somente serão
                  entregues com a confirmação de quitação de todas as parcelas e
                  quitação de todos os integrantes aderidos a este contrato, e
                  ainda, quando o caso, após a negociação de ajuste quanto a
                  quantidade a ratear, conforme descrito nesta cláusula.
                </p>
                {this.props.contrato.numero != 30726 ? (
                  <p>
                    E, por estarem assim justos e contratados, o foro da cidade de
                    Bandeirantes - PR fica nomeado para dirimir quaisquer dúvidas
                    que não sejam resolvidas em acordo.
                  </p>
                ) : (
                  <p>
                    E, por estarem assim justos e contratados, o fórum da cidade
                    de Uberaba - MG fica nomeado para dirimir quaisquer dúvidas
                    que não sejam resolvidas em acordo.
                  </p>
                )}
              </div>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '16px',
              flexWrap: 'wrap'
            }}>
              <div style={{
                background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                padding: '12px 16px',
                borderRadius: '10px',
                border: '1px solid #93c5fd',
                flex: 1,
                minWidth: '250px'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <i className='fa fa-shield-alt' style={{ color: '#1e40af', fontSize: '18px' }}></i>
                  <span style={{ fontSize: '13px', color: '#1e40af', fontWeight: '600' }}>
                    Leia atentamente antes de concordar
                  </span>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '12px' }}>
                <Link to='./'>
                  <button
                    className="btn-cancelar-termo"
                    style={{
                      background: 'transparent',
                      color: '#64748b',
                      border: '2px solid #cbd5e1',
                      padding: '12px 28px',
                      borderRadius: '10px',
                      cursor: 'pointer',
                      fontWeight: '600',
                      fontSize: '15px',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    <i className='fa fa-times' style={{ marginRight: '8px' }}></i>
                    Cancelar
                  </button>
                </Link>
                <button
                  className="btn-concordar-termo"
                  style={{
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                    color: 'white',
                    border: 'none',
                    padding: '12px 32px',
                    borderRadius: '10px',
                    cursor: 'pointer',
                    fontWeight: '700',
                    fontSize: '15px',
                    boxShadow: '0 6px 20px rgba(16, 185, 129, 0.3)',
                    transition: 'all 0.3s ease'
                  }}
                  onClick={this.handleClickTermoAditamento.bind(this)}
                >
                  <i className='fa fa-check' style={{ marginRight: '8px' }}></i>
                  Concordo com os termos
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Joyride
          continuous={true}
          run={this.state.run}
          scrollToFirstStep={true}
          showProgress={true}
          showSkipButton={true}
          steps={this.state.steps}
          styles={{ options: { zIndex: 10000 } }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    itens: state.item.todosDistribuiveis,
    formandos: state.formando.todos,
    contrato: state.contrato.especifico,
    usuario: state.usuario.autenticado,
    numeroContrato: state.usuario.numeroContrato,
  };
};

export default connect(mapStateToProps, {
  editarCamposContrato,
  editarCamposFormando,
  adicionarItem,
  editarItem,
  cadastrarAcao,
  removerItemFormando,
  adicionarItemFormando,
  obterFormandosPeloContrato,
  obterItensTipoFTab,
  editarContrato,
  descobrirContrato,
})(DistribuirItensFormando);